import { useResponsiveProp } from "@shopify/restyle";
import { ScrollView } from "react-native";

import {
  HStack,
  Box,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

export const EventsLayout = ({
  header,
  eventsList,
  sidebarContent,
  shouldCenter,
}: {
  header: React.ReactNode;
  eventsList: React.ReactNode;
  sidebarContent: React.ReactNode;
  shouldCenter: boolean;
}) => {
  const shouldDisplayScrollView = useResponsiveProp({
    base: 0,
    md: 1,
  });
  return (
    <Box
      flex={1}
      height="100%"
      backgroundColor="surface-primary"
      safeAreaTop
      width={"100%"}
    >
      {/**
       * This Box exists purely to color the left portion of the screen white
       * when on larger screens
       */}
      <Box
        width="50%"
        position="absolute"
        left={0}
        top={0}
        bottom={0}
        backgroundColor="surface-primary"
      />
      <Box
        flex={1}
        maxWidth={shouldCenter ? 1240 : "auto"}
        width="100%"
        marginHorizontal={shouldCenter ? "auto" : 0}
        paddingHorizontal={{ base: 0 }}
      >
        <HStack
          flex={1}
          backgroundColor="surface-secondary"
          flexDirection={{ base: "column", md: "row" }}
        >
          <VStack
            width={{ base: "auto", md: 400 }}
            zIndex={100}
            backgroundColor={{
              base: "transparent",
              md: "surface-primary",
            }}
            borderRightWidth={1}
            borderRightColor="outline-default"
            height={{ base: "auto", md: "100%" }}
          >
            {header}
            {shouldDisplayScrollView ? (
              <ScrollView
                style={{
                  height: "100%",
                  marginBottom: 24,
                  paddingTop: 16,
                  paddingHorizontal: 16,
                  display: "flex",
                }}
                contentContainerStyle={{
                  height: "100%",
                  flex: 1,
                }}
              >
                {sidebarContent}
              </ScrollView>
            ) : null}
          </VStack>
          <VStack flex={1} backgroundColor="surface-primary">
            {eventsList}
          </VStack>
        </HStack>
      </Box>
    </Box>
  );
};
